// extracted by mini-css-extract-plugin
export default {"root":"Search_root__Rk2Zy","input":"Search_input__ddKXh","searchBtn":"Search_searchBtn__LMni9"};